import React, { useCallback } from "react";
import * as R from "ramda";
import { connect } from "react-redux";
import { compose } from "recompose";
import { withTranslation } from "react-i18next";
import { Content } from "@worcket/common/components/layout";
import shortid from "shortid";

import { saveOpportunitySteps } from "../../../../../store/actions/opportunity";
import ProcessEditor from "../../OpportunityProcess/ProcessEditor/ProcessEditor";

const mapIndexed = R.addIndex(R.map);

const ProcessForm = ({ saveOpportunitySteps, initialSteps }) => {
  const handleSubmit = useCallback(
    async steps => {
      const parsedSteps = R.pipe(
        R.defaultTo([]),
        mapIndexed((step, index) => R.assoc("order", index + 1)(step))
      )(steps);

      await saveOpportunitySteps({
        formData: {
          steps: parsedSteps
        }
      });
    },
    [saveOpportunitySteps]
  );

  return (
    <Content>
      <ProcessEditor
        initialSteps={initialSteps}
        onSubmit={handleSubmit}
        isWizard
      />
    </Content>
  );
};

const enhancer = compose(
  connect(
    (state, { opportunity }) => ({
      initialSteps: R.pipe(
        R.propOr([], "steps"),
        R.map(R.pipe(step => ({ ...step, id: shortid.generate() })))
      )(opportunity)
    }),
    {
      saveOpportunitySteps
    }
  ),
  withTranslation(["opportunity", "form", "global"])
);

export default enhancer(ProcessForm);
